class FAQ extends HTMLElement {
  constructor() {
    super();

    this.btnQuery = this.querySelectorAll('.btn-query');
    let self = this;

    this.btnQuery.forEach(btn => {
      btn.addEventListener('click', function() {
        self.handleOpenCloseQuery(btn);
      });
    });

  }

  handleOpenCloseQuery(btn) {
    let parent = btn.closest('.query-faq');
    if (!parent.classList.contains('open')) {
      document.querySelector('.query-faq.open')?.classList.remove('open');
      parent.classList.add('open');
    } else {
      parent.classList.remove('open');
    }
  }
}

customElements.define('faq-section', FAQ);
